










































import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref
} from "@vue/composition-api";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { GLOBAL_MESSAGE } from "@/helpers/hooks/useGlobalMessage";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { useRouter } from "@/router";
import { useStore } from "@/store";
// import { useRoute, useRouter } from "@/router"; // TODO: vue-router4移行時に書き換える

export default defineComponent({
  name: "GlobalMessageBar",
  components: {
    Heading
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    // const route = useRoute(); // TODO: vue-router4移行時に書き換える
    const { messages } = useGlobalState(GLOBAL_MESSAGE);

    const displayMessages = computed(() => {
      // エージェント画面を表示している際、求人掲載や採用計画の通知メッセージは必要ないため非表示とする
      if (store.getters["domains/user/isScoutAgentMenuActive"]) {
        return [];
      }

      return messages.value.filter(message => {
        if (!message.exclusionPages) {
          return true;
        }

        return message.exclusionPages.some(exclusionPage => {
          // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
          // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
          // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
          const route = getCurrentInstance()?.proxy.$root.$route ?? {
            path: ""
          }; // TODO: vue-router4移行時に削除してuseRouteで生成したrouteにアクセスさせる
          const exclusionRouterResolved = router.resolve(exclusionPage);

          return exclusionRouterResolved.route.path !== route.path;
        });
      });
    });

    const closedMessageKeyList = ref<string[]>([]);

    const closeMessage = (key: string) => {
      closedMessageKeyList.value.push(key);
    };

    const isClosedMessage = (key: string) => {
      return closedMessageKeyList.value.includes(key);
    };

    return {
      displayMessages,
      closeMessage,
      closedMessageKeyList,
      isClosedMessage
    };
  }
});
